import { fetch } from '../env/browser';

export interface FetchJsonResult<T = unknown> {
  json: T;
  lastModified: string | null;
}

export async function fetchJson<T = unknown>(
  url: string,
  options: RequestInit = {}
): Promise<FetchJsonResult<T>> {
  const response = await fetch(url, {
    method: 'GET',
    ...options,
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
      ...options.headers,
    },
  });

  const json = (await response.json()) as T;
  const lastModified = response.headers.get('last-modified');

  return { json, lastModified };
}

export const fetchHeaders = (
  url: string,
  names: string[] = []
): Promise<(string | null)[]> =>
  fetch(url, { method: 'HEAD' }).then((res: Response) =>
    names.map((name) => res.headers.get(name))
  );
